import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Navbar.module.css";
import logo from "../assets/logo_wide.png";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // スクロール検知による表示制御
    React.useEffect(() => {
        const controlNavbar = () => {
            if (window.scrollY > lastScrollY && window.scrollY > 100) {
                // 下にスクロール かつ 100px以上スクロールしている場合 -> 隠す
                setShow(false);
            } else {
                // 上にスクロール -> 表示
                setShow(true);
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener('scroll', controlNavbar);
        return () => {
            window.removeEventListener('scroll', controlNavbar);
        };
    }, [lastScrollY]);

    return (
        <div className={`${styles.navigation} ${show ? '' : styles.hidden}`}>
            <nav>
                <Link to="/" onClick={closeMenu}>
                    <img src={logo} alt="MyLogo" className={styles.logoImage} />
                </Link>

                {/* ハンバーガーアイコン */}
                <div
                    className={`${styles.hamburger} ${menuOpen ? styles.open : ""}`}
                    onClick={toggleMenu}
                >
                    <span className={styles.bar}></span>
                </div>

                <ul className={`${styles.navLinks} ${menuOpen ? styles.showMenu : ""}`}>
                    <li className={styles.hasSubmenu}>
                        <Link to="/Aboutus" onClick={closeMenu}>
                            会社概要
                        </Link>
                        <ul className={styles.submenu}>
                            <li>
                                <Link to="/Aboutus#company-overview" onClick={closeMenu}>
                                    会社情報
                                </Link>
                            </li>
                            <li>
                                <Link to="/Aboutus#ceo-greeting" onClick={closeMenu}>
                                    代表挨拶
                                </Link>
                            </li>
                            <li>
                                <Link to="/Aboutus#member-intro" onClick={closeMenu}>
                                    メンバー紹介
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/work" onClick={closeMenu}>
                            ワークス
                        </Link>
                    </li>
                    <li className={styles.hasSubmenu}>
                        <Link to="/recruit" onClick={closeMenu}>
                            採用情報
                        </Link>
                        <ul className={styles.submenu}>
                            <li>
                                <Link to="/recruit" onClick={closeMenu}>
                                    採用情報TOP
                                </Link>
                            </li>
                            <li>
                                <Link to="/recruit#work-style" onClick={closeMenu}>
                                    働き方
                                </Link>
                            </li>
                            <li>
                                <Link to="/recruitInfo" onClick={closeMenu}>
                                    募集要項
                                </Link>
                            </li>
                            <li>
                                <Link to="/internship" onClick={closeMenu}>
                                    インターンシップ
                                </Link>
                            </li>
                            <li>
                                <Link to="/recruitIntern" onClick={closeMenu}>
                                    学校の方へ
                                </Link>
                            </li>
                            <li>
                                <Link to="/recruit#recruit-faq" onClick={closeMenu}>
                                    FAQ
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/contact" onClick={closeMenu}>
                            お問い合わせ
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/en" onClick={closeMenu}>
                            English
                        </Link>
                    </li> */}
                </ul>
            </nav>
        </div>
    );
}

export default Navbar;
